import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'

$(document).on('turbo:load turbo:render', () => {
  const unitIndex = document.querySelector('#unit-index')
  if (unitIndex && !unitIndex.__vue_app__) {
    createApp({ components: { BaseAlert } }).mount(unitIndex)
  }
})
